import React, { Component } from "react";
import { Row, Card, CardTitle, Form, Label, Input, Button } from "reactstrap";
import { NavLink } from "react-router-dom";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import IntlMessages from "../../../../helpers/IntlMessages";
import { AxiosUserAPI, getUserID } from '../../../../helpers/AxiosAPI';
import { postAPI_UpdatePin, postAPI_VerifyForgotPassword } from '../../../../constants/APIs';
import { NotificationManager } from "../../../../components/common/react-notifications";
import { connect } from "react-redux";
class ChangePin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reason: 'ForgotFlow',
      oldPassword: '',
      password: '',
      creator: 'user'
    };
  }


  handleChangePassword = password => {
    this.setState({
      password: password.target.value,
    });
  };

  handleChangeoldPassword = password => {
    this.setState({
      oldPassword: password.target.value,
    });
  };

  onUserResetPassword() {
    let data = {
      reason: 'UserInitiatedReset',
      oldPin: this.state.oldPassword,
      pin: this.state.password,
      creator: 'user'
    }

    AxiosUserAPI({
      method: 'put',
      url: `${postAPI_UpdatePin}/${getUserID()}/change-pin`,
      data: data
    }).then(
      res => {
        NotificationManager.success(
          "Pin Changed Successfully",
          "Pin Changed Success",
          3000,
          null,
          null,
          "success"
        );
      },
      error => {
        console.log('eee.data', error.data);
      }
    );
  }

  render() {
    return (
      <Row className="h-100">
        <Colxx xxs="12" md="10" className="mx-auto my-auto">
          <Card className="auth-card">
            <div className="position-relative image-side ">
              <p className="text-white h2">a voucher distribution system for savvy tourism businesses</p>
              <p className="white mb-0">
                Please enter the new pin.
              </p>
            </div>
            <div className="form-side">
              <CardTitle className="mb-4">
                 {this.props.checkPin ===true ? 'Change Pin' : 'Create Pin'}
              </CardTitle>
              <Form>
                {this.props.checkPin ===true && <Label className="form-group has-float-label mb-4">
                  <Input type="password" onChange={this.handleChangeoldPassword} />
                  <IntlMessages id="user.currentpin" />
                </Label>}
                <Label className="form-group has-float-label mb-4">
                  <Input type="password" onChange={this.handleChangePassword} />
                  <IntlMessages id="user.newpin" />
                </Label>
                <Label className="form-group has-float-label mb-4">
                  <Input type="password" />
                  <IntlMessages id="user.newpinagain" />
                </Label>
                <div className="d-flex justify-content-end align-items-center">
                  <Button
                    color="primary"
                    className="btn-shadow aiva-background"
                    size="lg"
                    onClick={() => this.onUserResetPassword()}
                  >
                    <IntlMessages id="user.reset-password-button" />
                  </Button>
                  <Button                                        
                    className="btn-shadow ml-2"
                    size="lg"
                    onClick={() => window.location.href="/app/pages/redeemVouchers"}
                  >
                   Back
                  </Button>
                </div>
              </Form>
            </div>
          </Card>
        </Colxx>
        
      </Row>
    );
  }
}
const mapStateToProps = ({ settings }) => {
  const { checkPin} = settings;
  return {
    checkPin
  };
};

export default (connect(mapStateToProps, {})(ChangePin));